<template>
  <a-modal
          title="抽样结果上传"
          okText="确定"
          cancelText="取消"
          width="700px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="受检单位名称" prop="name">
            <a-ext-bold-a v-model="formState.name"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="抽样数量" prop="pickCount">
            <a-ext-bold-a v-model="formState.pickCount"></a-ext-bold-a>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="抽样单上传" prop="pickFile">
            <div style="width: 90%">
              <a-ext-upload :disabled="param.disabled" v-model="formState.pickFile"></a-ext-upload>
            </div>

          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtBoldA from '../../../components/AntDesignExt/All/AExtBoldA'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import {addorUpdateMonitPick as saveApi,getMonitPickById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtBoldA,AExtUpload,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                name:'',
                pick_count:'',
                pick_file:'',
            },
            rules: {

            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi({id:this.param.id}).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("pickResultUploadModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>